export const APP_VERSION = 'v2025.0805';
